// Ensures the name starts with a valid identifier character and only contains [a-zA-Z0-9_].
export const sanitizeUsernameForOperationName = (username: string): string =>
	username.replace(/^[^a-zA-Z_]/, '_').replace(/[^a-zA-Z0-9_]/g, '_');
